var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/getDepNumberByRef.ts";
import "core-js/modules/es.array.find-index.js";
export var getDepNumberByRef = function getDepNumberByRef(refNode, currentEntity) {
  var depIdx = currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.sourceClassifiers.findIndex(function (_ref) {
    var id = _ref.id;
    return id === (refNode === null || refNode === void 0 ? void 0 : refNode.parentClassifierId);
  });

  if (typeof depIdx === 'undefined' || depIdx === -1) {
    return null;
  }

  return depIdx + 1;
};